import { environment } from "../../environments/environment";
import { bootDemo, demoUser } from "./demo/bootDemo";
import {
  OidcAuthenticationService,
  OidcUser,
} from "firefly-shared-ts-authentication-oidc";
import { SystemDao } from "firefly-chimney-insights-ts-domain";
import { ChimneyInsightsBootResult } from "./ChimneyInsightsBootResult";
import { UnauthenticatedError } from "shared-ts-ui-app-boot";
import { User } from "shared-ts-utils-authentication";
import { StringSetting, UserSettings } from "shared-ts-utils-user-settings";
import { appKey } from "../../appInfo";
import { MunicipalityDao } from "firefly-shared-ts-domain";
import { resolveCustomerEnvironment } from "firefly-shared-ts-customer-environment";

const loadUser = async (
  authService: OidcAuthenticationService
): Promise<User> => {
  const oidcClientUser = await authService.getUser();
  if (oidcClientUser == null) {
    throw new UnauthenticatedError();
  }
  return new OidcUser(oidcClientUser);
};

export const boot = async (args: {
  onMessage: (message: string) => void;
  onError: (error: Error) => void;
}): Promise<ChimneyInsightsBootResult> => {
  const authService = OidcAuthenticationService.get();
  const useBackend = await resolveUseBackend();
  console.info(" useBackend " + useBackend);
  if (!useBackend) {
    args.onMessage("Genererer demo data.");
    await bootDemo();
  }

  args.onMessage("Laster brukerinfo");
  const user = useBackend ? await loadUser(authService) : demoUser;

  const userSettings = new UserSettings({
    user: user,
    app: appKey,
  });
  let language = await userSettings.read("language", StringSetting);
  if (language == null) {
    language = "nb-NO";
    await userSettings.write("language", language, StringSetting);
  } else {
    const localAppLanguage = localStorage.getItem(`${appKey}:language`);
    if (localAppLanguage !== language) {
      localStorage.setItem(`${appKey}::language`, language);
    }
  }

  const systemDao = new SystemDao({ accessToken: user.accessToken });
  args.onMessage("Laster kundemiljøer");
  const environments = await systemDao.getCustomerEnvironments();
  const previousChosenEnvironment = userSettings.read(
    "customerEnvironment",
    StringSetting
  );
  const chosenEnvironment = resolveCustomerEnvironment({
    environments: environments,
    previousChosenEnvironment: previousChosenEnvironment,
  });

  const municipalityDao = new MunicipalityDao({
    accessToken: user.accessToken,
    customerEnvironment: chosenEnvironment,
  });
  args.onMessage("Laster kommuner");
  const municipalities = await municipalityDao.getList();

  return {
    customerEnvironments: environments,
    municipalities: municipalities,
    user: user,
  };
};

const resolveUseBackend = async (): Promise<boolean> => {
  if (environment.production) {
    return Promise.resolve(true);
  }
  try {
    await new SystemDao().ping();
    return Promise.resolve(true);
  } catch (e) {
    return Promise.resolve(false);
  }
};
